import { module } from 'modujs';
import Ukiyo from 'ukiyojs';

export default class extends module {
    constructor(m) {
        super(m);
        this.items = [...this.el.querySelectorAll('[data-parallax]')];
        console.log(this.items)
        this.instance = null;
    }

    init() {
        if (!this.items.length) return;

        this.instance = new Ukiyo(this.items, {
            scale: 1.3,
            speed: 1.5,
            willChange: true,
        });
    }

    destroy() {
        if (this.instance) {
            this.instance.destroy();
            this.instance = null;
        }
    }
}